import { dimensionsKeys } from "../../../../../../utils";

export const getLowestFilteredDimensionKey = (filtersData) => {
  const appliedFilters = Object.keys(filtersData)
    .sort((a, b) => dimensionsKeys.indexOf(a) - dimensionsKeys.indexOf(b));
  return appliedFilters.at(-1);
};

export const getNextLowestFilteredDimensionKey = (filtersData) => {
  const appliedFilters = Object.keys(filtersData)
    .sort((a, b) => dimensionsKeys.indexOf(a) - dimensionsKeys.indexOf(b));
  return appliedFilters.at(-2);
};

export const dataTypeColours = {
  "stationary": "hsla(50,100%,50%,0.49)",
  "mobile": "hsla(50,100%,50%,0.49)",
  "refrigerant": "hsla(50,100%,50%,0.49)",
  "electricity": "hsla(0,100%,50%,0.62)",
  "scopeThreeCategory": "hsla(212,100%,50%,0.75)"
};